/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconHourglassBottom/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconHourglassBottom({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconHourglassBottom",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#323232",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconHourglassBottom.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1PmG2O': alignSelf,'--mt-2-1PmG2O': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1PmG2O': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1PmG2O': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1PmG2O': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1PmG2O': opacity,'--w-10-1PmG2O': typeof width === 'number' ? `${width}px` : width,'--h-11-1PmG2O': typeof height === 'number' ? `${height}px` : height,'--f-12-1PmG2O': fill,'--a-7-1PmG2O': isAnimated ? animation : "none",'--sd-8-1PmG2O': isAnimated ? strokeDashoffset : 0,'--sd-9-1PmG2O': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconHourglassBottom.SvgPath"
  data-view-path={viewPath}
 d="M18 22l-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}